<template>
    <footer class="footer" style="padding:0 0 3rem 0;">
        <hr style="border-top: 0.0625rem solid rgb(244 245 247 / 10%);">
        <div class="container">
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div>
                        <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                            <img src="img/brand/logo.png" alt="logo">
                        </router-link>
                    </div>
                    <div class="copyright">
                        태안현아호 | 충남 태안군 근흥면 신진도리 542 안흥외항선착장
                        <br>대표전화 010-6420-3139
                        <br> 
                        <br>&copy; 2024 DAOM, ALL RIGHTS RESERVED                   
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <a href="/location" class="nav-link"  rel="noopener">오시는 길</a>
                        </li>
                        <li class="nav-item">
                            <a href="/introduce" class="nav-link"  rel="noopener">선박소개</a>
                        </li>
                        <li class="nav-item">
                            <a href="/benefit" class="nav-link"  rel="noopener">환불규정</a>
                        </li>
                        <li class="nav-item">
                            <a href="/customer"
                               class="nav-link"  rel="noopener">문의하기</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <base-alert type="secondary" class="hidden" style="position: fixed; width: 100vw; bottom: 1px;">
            <strong>복사완료!</strong> 계좌번호가 복사되었습니다!
        </base-alert>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
